import React, { useState } from 'react'
import CollectionItem from '../../components/sub-collection-item'
import { Swiper, SwiperSlide } from 'swiper/react';
import Next from '-!svg-react-loader!../../assets/images/slide-arrow-next.svg';
import Prev from '-!svg-react-loader!../../assets/images/slide-arrow-prev.svg';
import { breakpoints } from '../../utils/helpers'
import { Link } from 'gatsby';

const CollectionSubs = ({ subs, current, parent }) => {
    const [swiper, setSwiper] = useState(null);
    if (!subs) { return null }

    let url = '/collection/';

    return (
        <>
            <div className="Collection__subs">
                <div className="Collection__subs__title">
                    <h6>Explore Our <br />
                        Subcategories:</h6>
                </div>
                <div className="Collection__subs__list">
                    <button
                      className='Nav__button next'
                      aria-label='next'
                      onClick={() => swiper.slideNext()}
                    >
                      <Next />
                    </button>
                    <button
                      className='Nav__button prev'
                      aria-label='prev'
                      onClick={() => swiper.slidePrev()}
                    >
                      <Prev />
                    </button>

                    <Swiper
                        loop={true}
                        spaceBetween={11}
                        slidesPerView={1}
                        onSwiper={setSwiper}
                        className='Collection__subs__main'
                        breakpoints={{
                            [breakpoints.xs]: {
                                slidesPerView: subs.length >= 2 ? 2 : subs.length
                            },
                            [breakpoints.md]: {
                                slidesPerView: subs.length >= 5 ? 5 : subs.length
                            },
                            [breakpoints.xxl]: {
                                slidesPerView: subs.length >= 5 ? 5 : subs.length
                            },
                            [breakpoints.bigger]: {
                                slidesPerView: subs.length >= 6 ? 6 : subs.length
                            }
                        }}
                    >
                        {subs.map((sub, index) => (
                            <SwiperSlide className="Collection__subs__slider" key={index}>
                                <Link to={url + sub.handle}>
                                    <CollectionItem data={sub} key={index} />
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>
            </div>
        </>
    )
}

export default CollectionSubs